jQuery(function($) {

  /* WooCommerce Input Quantity on Single Product
  ---------------------------------------- */
  jQuery('body').on( 'click', 'button.plus, button.minus', function() {
 
    // Get current quantity values
    var qty =  jQuery( this ).parent().find( '.qty' );
    var val   = parseFloat(qty.val());
    var max = parseFloat(qty.attr( 'max' ));
    var min = parseFloat(qty.attr( 'min' ));
    var step = parseFloat(qty.attr( 'step' ));

    // Change the value if plus or minus
    if (  jQuery( this ).is( '.plus' ) ) {
        if ( max && ( max <= val ) ) {
          qty.val( max );
        } else {
          qty.val( val + step );
        }
    } else {
        if ( min && ( min >= val ) ) {
          qty.val( min );
        } else if ( val > 1 ) {
          qty.val( val - step );
        }
    }
        
  });

  jQuery('body').on('click', '.plus, .minus', function(e) {
    var btnupdate = $('form.woocommerce-cart-form').find( 'button[name="update_cart"]' );
    btnupdate.removeAttr('disabled');
  });


  /* WooCommerce - Single Product JS
  ---------------------------------------- */

  jQuery('.woocommerce-PaymentMethod .button.delete').html('<i class="icon-trash text-4xl"></i>');

  jQuery('#show-more').on('click', function(e) {
    jQuery('.full-product-description').toggleClass( 'max-h-28 overflow-hidden' );
    jQuery('#show-more').toggleClass(' open');
  });

  jQuery('.ywapo_label .required').text('*');

  $(window).on("load resize",function() {
    if($('.wpgis-slider-for').length){
      $('.wpgis-slider-for').slick('slickSetOption', 'responsive', [{breakpoint: 767, settings: {verticalSwiping: false}}], true);
    }
  });

  $(window).on("load resize",function() {
    if($('.wpgis-slider-nav').length){
      $('.wpgis-slider-nav').slick('slickSetOption', 'arrows', true, true);
    }
  });



  $(window).on("load resize",function() {
    if($('.wpgis-slider-nav').length){
      $('.wpgis-slider-nav').slick('slickSetOption', 'prevArrow', '<button class="product-slider-prev" title="Previous Product"><i class="text-xs icon-Angle-up"></i></button>', true);
    }
  });
 
  $(window).on("load resize",function() {
    if($('.wpgis-slider-nav').length){
      $('.wpgis-slider-nav').slick('slickSetOption', 'nextArrow', '<button class="product-slider-next" title="Next Product"><i class="text-xs icon-Angle-up"></i></button>', true);
    }
  });

  //Single product - js for select dropdown on mobile

  $( 'body' )
  // Tabs

    .on( 'change', 'select.select-tabs', function( e ) { //on change of a select dropdown...
      e.preventDefault();

      var $tab          = $( this );
      var $tabs_wrapper = $tab.closest( '.wc-tabs-wrapper, .woocommerce-tabs' );
      var $tabs         = $tabs_wrapper.find( '.wc-tabs, ul.tabs' );

      $tabs.find( 'li' ).removeClass( 'active' ); //keeping the normal ul li list up to date 
      $tabs_wrapper.find( '.wc-tab, .panel:not(.panel .panel)' ).hide(); //hide all panels

      $tabs.find('a[href="#' + $tab.val()  + '"]').parent().addClass( 'active' ); //keeping the normal ul li list up to date

      $tabs_wrapper.find( '#' + $tab.val() ).show(); //show the tab with the id of the value of the option chosen

    } )

    .on( 'click', '.wc-tabs li a, ul.tabs li a', function( e ) { //extending the current woo function for this to update the select dropdown too
      e.preventDefault();
      var $tab_value  = $( this ).attr( 'href' ).replace('#','');

      $('.select-tabs').val(  $tab_value ); //update the select with this value
  });


  jQuery( '.woocommerce-ordering' ).on( 'change', 'select.per-page', function() {
    jQuery( this ).closest( 'form' ).submit();
  });

  jQuery('#feefo-total-reviews').on('click', function(e) {
    jQuery('.woocommerce-tabs > ul > li').removeClass('active');
	jQuery('.woocommerce-tabs .woocommerce-Tabs-panel').removeAttr('style',);

    jQuery('#tab-title-reviews_tab').addClass('active');
    jQuery('.woocommerce-tabs .woocommerce-Tabs-panel:not(#tab-reviews_tab)').attr('style', 'display: none;');
  });


  jQuery(document).keyup(function(e) {
    if (e.keyCode == 27 && jQuery(".woo-filters-wrapper").hasClass('open')) {  //if escape key is pressed and the navigation is open
        jQuery('.woo-filters-wrapper').removeClass('open');
    }
  });

  //Add Paypal icon on checkout page after checkout is updated and hide Paypal text
  $( 'body' ).on( 'updated_checkout', function() {

    if ( jQuery("label[for='payment_method_ppcp-gateway']").length ) {
        jQuery("label[for='payment_method_ppcp-gateway']").append('<img src="/wp-content/themes/laughingdog-woo/graphics/paypal.png" alt="Paypal">');
        jQuery("label[for='payment_method_ppcp-gateway']").addClass('hide-text');
    }

  });

});

document.addEventListener("DOMContentLoaded", function() {
    // Add attribute aria-label to the trigger on product gallery
    let wpgis_popup_trigger = document.querySelectorAll('.wpgis-popup');
    if(wpgis_popup_trigger){
      wpgis_popup_trigger.forEach(function(trigger){
        trigger.setAttribute('aria-label', 'Open product gallery');
      });
    }
});


document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("claim-order-form");
  const responseContainer = document.getElementById("claim-order-response");

  if (!form) return;

  form.addEventListener("submit", function (e) {
      e.preventDefault();

      const orderID = document.getElementById("order_id").value.trim();
      const orderEmail = document.getElementById("order_email").value.trim();

      if (!orderID || !orderEmail) {
          responseContainer.innerHTML = "<p style='color: red;'>All fields are required.</p>";
          return;
      }

      const formData = new FormData();
      formData.append("action", "custom_process_claim_order_request");
      formData.append("order_id", orderID);
      formData.append("order_email", orderEmail);

      fetch(ajaxurl.url, {
          method: "POST",
          body: formData,
      })
          .then((response) => response.json())
          .then((data) => {
              responseContainer.innerHTML = `<p style='color: ${data.success ? "green" : "red"};'>${data.message}</p>`;
              if (data.success) {
                  setTimeout(() => location.reload(), 2000);
              }
          })
          .catch(() => {
              responseContainer.innerHTML = "<p style='color: red;'>An error occurred. Please try again.</p>";
          });
  });
});

// Enquiry Modal

document.addEventListener("DOMContentLoaded", function() {
  let modal = document.getElementById("enquiry-modal");
  let btn = document.getElementById("enquire-now-btn");
  let close = document.getElementById("enquiry-modal-close");

  if (btn) {
      btn.onclick = function() {
          modal.style.display = "flex";
          document.documentElement.classList.add("modal-open");
      };
  }

  if (close) {
      close.onclick = function() {
          modal.style.display = "none";
      };
  }

  // Close modal when clicking outside of it
  window.onclick = function(event) {
      if (event.target == modal) {
          modal.style.display = "none";
          document.documentElement.classList.remove("modal-open");;
      }
  };

  // Close modal when pressing the Escape key
  document.addEventListener("keydown", function(event) {
      if (event.key === "Escape" && modal.style.display === "flex") {
          modal.style.display = "none";
          document.documentElement.classList.remove("modal-open");
      }
  });
});

document.addEventListener('DOMContentLoaded', function() {

  //if we're on the woo cart
  if(document.body.classList.contains('woocommerce-cart')) {

      //define a new function to format the cart into the input field
      const update_cart_field = () => {

          //fetch the cart element
          let cart = document.querySelector('.cart');

          //look for a cart input field
          let cart_field = document.querySelector('input[name="cart_data"], textarea[name="cart_data"]');

          //if we have both a cart and a cart field...
          if(cart && cart_field) {

              //get all the cart items
              let cart_items = cart.querySelectorAll('.cart_item');

              //define a new string to hold the cart text
              let cart_text = '';

              //loop through each cart item
              cart_items.forEach((item) => {

                  //get the product name
                  let product_name = item.querySelector('.product-name').innerText;

                  //clean up the product name
                  product_name = product_name.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();

                  //if the product name contains 'Product Code'
                  if(product_name.indexOf('Product Code') > -1) {

                      //wrap it in brackets
                      product_name = product_name.replace('Product Code: ', '(').trim() + ')';
                  }

                  //get the product quantity
                  let product_quantity = item.querySelector('.qty').value;

                  //get the product price
                  let product_price = item.querySelector('.product-price').innerText;

                  //add the product to the cart text
                  cart_text += `\u2022 ${product_name} x ${product_quantity} @ ${product_price}\n`;

              });

              //if we have a cart text
              if(cart_text != '') {

                  //set the cart field value to the cart text
                  cart_field.value = cart_text;
              }
          }
      };

      //run the function on load
      update_cart_field();

      //run the function on all clicks
      document.addEventListener('click', update_cart_field);

  }

});

document.addEventListener('DOMContentLoaded', function () {

  // Check weight on single product page
  const singleProductForm = document.querySelector('form.cart');
  if (singleProductForm) {
      const qtyInput = singleProductForm.querySelector('input.qty');
      const addToCartButton = singleProductForm.querySelector('button.single_add_to_cart_button');

      const checkWeightLimit = () => {
          if (typeof productData !== 'undefined' && qtyInput) {
              const totalWeight = productData.weight * parseFloat(qtyInput.value || 1);
              if (totalWeight > cartData.weightLimit) {
                  addToCartButton.disabled = true;

                  // Display a warning message
                  let warning = singleProductForm.querySelector('.weight-warning');
                  if (!warning) {
                      warning = document.createElement('div');
                      warning.className = 'woocommerce-error weight-warning';
                      warning.textContent = 'The total weight of this product exceeds the 65kg limit. Please reduce the quantity or contact us for assistance.';
                      singleProductForm.prepend(warning);
                  }
              } else {
                  addToCartButton.disabled = false;

                  // Remove the warning message if weight is within the limit
                  const warning = singleProductForm.querySelector('.weight-warning');
                  if (warning) warning.remove();
              }
          }
      };

      // Check weight on quantity change
      qtyInput.addEventListener('input', checkWeightLimit);

      // Initial check on page load
      checkWeightLimit();
  }
});